(function() {
  'use strict';

  const CLOUDINARY_CLOUD = 'dsvcreexw';
  const CLOUDINARY_PRESET = 'sixhats_custom_logo';

  const ROPE_HANDLE = 'rope-service';
  const BALL_MARKER_HANDLE = 'magnetic-ball-marker';

  const TEE_HOLDER_CLOUD = 'do8te5umr';
  const TEE_HOLDER_FOLDER = 'tee-holder-composites';

  const state = {
    rope: { active: false, action: '', color: '', customColor: '', refImageFile: null, refImageBase64: null, refImageUrl: '' },
    teeHolder: { active: false, styleTitle: '', variantId: null, elastic: '', compositeUrl: '' },
    ballMarker: { active: false },
    scorecard: { active: false, designType: '', color: '', variantId: null, quantity: 0, logoFile: null, logoBase64: null },
    teeClip: { active: false, designType: '', color: '', variantId: null, quantity: 0, logoFile: null, logoBase64: null }
  };

  function getProductForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getMainHatQuantity() {
    const qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    return qtyInput ? Math.max(1, parseInt(qtyInput.value) || 1) : 1;
  }

  function getMainHatVariantId() {
    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  async function uploadToCloudinary(base64Data, fileName) {
    const formData = new FormData();
    formData.append('file', base64Data);
    formData.append('upload_preset', CLOUDINARY_PRESET);
    formData.append('folder', 'product-page-upgrades');
    formData.append('context', 'original_filename=' + fileName + '|upload_date=' + new Date().toISOString());
    formData.append('tags', 'product-page,upgrade-logo');

    const res = await fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/upload', {
      method: 'POST',
      body: formData
    });
    if (!res.ok) {
      const err = await res.json();
      throw new Error((err.error && err.error.message) || 'Upload failed');
    }
    return await res.json();
  }

  function readFileAsBase64(file) {
    return new Promise(function(resolve, reject) {
      const reader = new FileReader();
      reader.onload = function(e) { resolve(e.target.result); };
      reader.onerror = function() { reject(new Error('File read failed')); };
      reader.readAsDataURL(file);
    });
  }

  function validateFile(file) {
    const allowedExt = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.pdf', '.eps', '.ai'];
    const ext = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    if (allowedExt.indexOf(ext) === -1) {
      alert('Invalid file type. Use PNG, JPG, GIF, SVG, PDF, EPS, or AI.');
      return false;
    }
    if (file.size / (1024 * 1024) > 10) {
      alert('File too large. Maximum 10MB.');
      return false;
    }
    return true;
  }

  function openModal(modalEl) {
    if (!modalEl) return;
    modalEl.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modalEl) {
    if (!modalEl) return;
    modalEl.style.display = 'none';
    document.body.style.overflow = '';
  }

  function setupModalCloseHandlers(modalEl) {
    if (!modalEl) return;
    const closeBtn = modalEl.querySelector('[data-modal-close]');
    const backdrop = modalEl.querySelector('[data-modal-backdrop]');
    if (closeBtn) closeBtn.addEventListener('click', function() { closeModal(modalEl); });
    if (backdrop) backdrop.addEventListener('click', function() { closeModal(modalEl); });
  }

  function updateCardBadge(cardKey, text) {
    const card = document.querySelector('[data-upgrade-card="' + cardKey + '"]');
    if (!card) return;
    let badge = card.querySelector('[data-card-badge]');
    if (text) {
      if (!badge) {
        badge = document.createElement('div');
        badge.setAttribute('data-card-badge', '');
        badge.className = 'fu-card-badge';
        card.appendChild(badge);
      }
      badge.textContent = text;
      card.classList.add('is-active');
    } else {
      if (badge) badge.remove();
      card.classList.remove('is-active');
    }
  }

  // ===========================================================================
  // Made-to-order lead time notice (rope + tee holder modals)
  // Injected just above each modal's Confirm button.
  // ===========================================================================
  function addLeadTimeNotice() {
    const targets = [
      document.querySelector('[data-rope-modal]'),
      document.querySelector('[data-tee-holder-modal]')
    ];
    targets.forEach(function(modal) {
      if (!modal || modal.querySelector('[data-leadtime-notice]')) return;
      const confirmBtn = modal.querySelector('[data-rope-confirm], [data-tee-holder-confirm]');
      if (!confirmBtn) return;
      const notice = document.createElement('p');
      notice.setAttribute('data-leadtime-notice', '');
      notice.style.cssText = 'margin:0 0 14px;padding:10px 12px;background:#f5f7fa;border-left:3px solid #185FA5;border-radius:6px;font-size:13px;line-height:1.45;color:#444;';
      notice.innerHTML = '<strong style="color:#185FA5;">Made to order.</strong> Every customization is finished by hand — please allow 24–48 hours to complete your hat upgrade before your order ships.';
      const footer = confirmBtn.closest('.fu-modal__footer');
      if (footer && footer.parentNode) {
        footer.parentNode.insertBefore(notice, footer);
      } else {
        confirmBtn.parentNode.insertBefore(notice, confirmBtn);
      }
    });
  }

  function upgradeRopeModalDOM() {
    const modal = document.querySelector('[data-rope-modal]');
    if (!modal) return;

    const otherBtn = modal.querySelector('[data-rope-color="Other"]');
    if (otherBtn) {
      otherBtn.setAttribute('data-rope-color', 'White');
      const circle = otherBtn.querySelector('.fu-modal__color-circle');
      if (circle) {
        circle.setAttribute('style', 'background:#ffffff;border:1px solid #d1d5db;');
      }
      otherBtn.childNodes.forEach(function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = '';
        }
      });
      otherBtn.appendChild(document.createTextNode('White'));
    }

    const customWrap = modal.querySelector('[data-rope-custom-color]');
    if (customWrap) {
      customWrap.style.display = 'block';
    }

    const customInput = modal.querySelector('[data-rope-custom-input]');
    if (customInput && customWrap && !customWrap.querySelector('[data-rope-custom-heading]')) {
      const heading = document.createElement('p');
      heading.className = 'fu-modal__section-title';
      heading.setAttribute('data-rope-custom-heading', '');
      heading.textContent = 'Or describe a custom color';
      customWrap.insertBefore(heading, customInput);
      customInput.setAttribute('placeholder', 'e.g. Navy, Coral, Tartan green plaid');
    }

    const colorSection = modal.querySelector('[data-rope-color-section]');
    if (colorSection && !colorSection.querySelector('[data-rope-ref-wrap]')) {
      const refWrap = document.createElement('div');
      refWrap.setAttribute('data-rope-ref-wrap', '');
      refWrap.innerHTML =
        '<p class="fu-modal__section-title">Upload a reference image (optional)</p>' +
        '<p style="font-size:11px;color:#5f5e5a;margin:0 0 8px;font-style:italic;">Helps our team match the exact rope you\'re looking for.</p>' +
        '<label class="fu-modal__upload" style="display:block;cursor:pointer;padding:16px;border:2px dashed #d1d5db;border-radius:6px;text-align:center;background:#f9fafb;">' +
          '<input type="file" accept="image/*,.pdf,.eps,.ai,.svg" data-rope-ref-upload style="display:none;">' +
          '<span data-rope-ref-label>Click to upload reference image</span>' +
        '</label>';
      colorSection.appendChild(refWrap);
    }
  }

  function setupRopeModal() {
    const modal = document.querySelector('[data-rope-modal]');
    if (!modal) return;
    setupModalCloseHandlers(modal);

    upgradeRopeModalDOM();

    const openBtn = document.querySelector('[data-upgrade-card="rope"]');
    const confirmBtn = modal.querySelector('[data-rope-confirm]');
    const colorSection = modal.querySelector('[data-rope-color-section]');
    const customInput = modal.querySelector('[data-rope-custom-input]');
    const refUploadInput = modal.querySelector('[data-rope-ref-upload]');
    const refLabel = modal.querySelector('[data-rope-ref-label]');
    const clearBtn = modal.querySelector('[data-rope-clear]');

    let pendingAction = '';
    let pendingColor = '';
    let pendingRefFile = null;
    let pendingRefBase64 = null;

    function getCustomText() {
      return customInput ? customInput.value.trim() : '';
    }

    function updateConfirm() {
      if (pendingAction === 'remove') {
        confirmBtn.disabled = false;
      } else if (pendingAction) {
        const hasPreset = pendingColor !== '';
        const hasCustom = getCustomText() !== '';
        confirmBtn.disabled = !(hasPreset || hasCustom);
      } else {
        confirmBtn.disabled = true;
      }
    }

    if (openBtn) openBtn.addEventListener('click', function() {
      openModal(modal);
      // Skip the action step: auto-select "Add" so the color options show immediately.
      if (!pendingAction) {
        let addBtn = modal.querySelector('[data-rope-action="add"]');
        if (!addBtn) {
          modal.querySelectorAll('[data-rope-action]').forEach(function(b) {
            if (!addBtn && (b.dataset.ropeAction || '').toLowerCase() === 'add') addBtn = b;
          });
        }
        if (addBtn) addBtn.click();
      }
    });

    modal.querySelectorAll('[data-rope-action]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingAction = this.dataset.ropeAction;
        modal.querySelectorAll('[data-rope-action]').forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (colorSection) colorSection.style.display = pendingAction === 'remove' ? 'none' : 'block';
        updateConfirm();
      });
    });

    modal.querySelectorAll('[data-rope-color]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingColor = this.dataset.ropeColor;
        modal.querySelectorAll('[data-rope-color]').forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (customInput && customInput.value.trim() !== '') {
          customInput.value = '';
        }
        updateConfirm();
      });
    });

    if (customInput) {
      customInput.addEventListener('input', function() {
        if (customInput.value.trim() !== '') {
          modal.querySelectorAll('[data-rope-color]').forEach(function(b) { b.classList.remove('is-selected'); });
          pendingColor = '';
        }
        updateConfirm();
      });
    }

    if (refUploadInput) {
      refUploadInput.addEventListener('change', async function(e) {
        const file = e.target.files[0];
        if (!file) {
          pendingRefFile = null;
          pendingRefBase64 = null;
          if (refLabel) refLabel.textContent = 'Click to upload reference image';
          return;
        }
        if (!validateFile(file)) {
          e.target.value = '';
          return;
        }
        pendingRefFile = file;
        pendingRefBase64 = await readFileAsBase64(file);
        if (refLabel) refLabel.innerHTML = '<span style="color:#16a34a;font-weight:500;">✓ ' + file.name + '</span>';
      });
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        state.rope.active = true;
        state.rope.action = pendingAction;
        const customText = getCustomText();
        if (pendingAction === 'remove') {
          state.rope.color = '';
          state.rope.customColor = '';
        } else if (customText) {
          state.rope.color = customText;
          state.rope.customColor = customText;
        } else {
          state.rope.color = pendingColor;
          state.rope.customColor = '';
        }
        state.rope.refImageFile = pendingRefFile;
        state.rope.refImageBase64 = pendingRefBase64;
        state.rope.refImageUrl = '';

        let label = state.rope.action.charAt(0).toUpperCase() + state.rope.action.slice(1);
        if (state.rope.color) label += ' • ' + state.rope.color;
        if (state.rope.refImageBase64) label += ' • image attached';
        updateCardBadge('rope', label);
        closeModal(modal);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        state.rope = { active: false, action: '', color: '', customColor: '', refImageFile: null, refImageBase64: null, refImageUrl: '' };
        updateCardBadge('rope', '');
        modal.querySelectorAll('.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
        pendingAction = ''; pendingColor = '';
        pendingRefFile = null; pendingRefBase64 = null;
        if (customInput) customInput.value = '';
        if (refUploadInput) refUploadInput.value = '';
        if (refLabel) refLabel.textContent = 'Click to upload reference image';
        if (colorSection) colorSection.style.display = 'none';
        confirmBtn.disabled = true;
        closeModal(modal);
      });
    }
  }

  function setupTeeHolderModal() {
    const modal = document.querySelector('[data-tee-holder-modal]');
    if (!modal) return;
    setupModalCloseHandlers(modal);

    const openBtn = document.querySelector('[data-upgrade-card="tee-holder"]');
    const confirmBtn = modal.querySelector('[data-tee-holder-confirm]');
    const styleSection = modal.querySelector('[data-tee-holder-style-section]');
    const previewSection = modal.querySelector('[data-tee-holder-preview-section]');
    const previewText = modal.querySelector('[data-tee-holder-preview-text]');
    const clearBtn = modal.querySelector('[data-tee-holder-clear]');

    let pendingStyle = '', pendingVariantId = null, pendingElastic = '';

    const HAT_SLUG_OVERRIDES = {
      'olive & brown suede': ['olive_green', 'olive-green']
    };

    function hatSlugVariations(hatName) {
      if (!hatName) return [];
      const trimmed = hatName.toString().toLowerCase().trim();
      const variations = [];

      if (HAT_SLUG_OVERRIDES[trimmed]) {
        HAT_SLUG_OVERRIDES[trimmed].forEach(function(slug) {
          variations.push(slug);
        });
      }

      variations.push(trimmed.replace(/&/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, ''));
      variations.push(trimmed.replace(/&/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, ''));

      if (trimmed.indexOf('plastic') !== -1) {
        const noPlastic = trimmed.replace(/plastic/g, '').replace(/\s+/g, ' ').trim();
        variations.push(noPlastic.replace(/&/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, ''));
        variations.push(noPlastic.replace(/&/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, ''));
      }

      if (trimmed.indexOf('plastic') !== -1 || trimmed.indexOf('mesh') !== -1) {
        const noPlasticMesh = trimmed.replace(/plastic/g, '').replace(/mesh/g, '').replace(/\s+/g, ' ').trim();
        if (noPlasticMesh) {
          variations.push(noPlasticMesh.replace(/&/g, '_').replace(/\s+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, ''));
          variations.push(noPlasticMesh.replace(/&/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, ''));
        }
      }

      if (trimmed.indexOf('&') !== -1) {
        const beforeAmp = trimmed.split('&')[0].trim();
        if (beforeAmp) variations.push(beforeAmp.replace(/\s+/g, '-'));
      }

      return [...new Set(variations)];
    }

    function hatSlug(hatName) {
      const v = hatSlugVariations(hatName);
      return v[0] || '';
    }

    function materialSlugVariations(materialName) {
      if (!materialName) return [];
      let s = materialName.toString().trim();
      const variations = [];

      const withBorderMatch = s.match(/^(.*?)\s+with\s+(.+?)\s+border$/i);
      if (withBorderMatch) {
        const base = withBorderMatch[1].toLowerCase().replace(/&/g, '').replace(/\s+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
        const border = withBorderMatch[2].toLowerCase().replace(/\s+/g, '_');
        variations.push(base + '-_' + border + '_border');
        return variations;
      }

      const fullSlug = s.toLowerCase().replace(/&/g, '').replace(/\s+/g, '_').replace(/_+/g, '_').replace(/^_|_$/g, '');
      variations.push(fullSlug);

      const droppableSuffixes = ['_leather', '_patch'];
      droppableSuffixes.forEach(function(suffix) {
        if (fullSlug.endsWith(suffix)) {
          variations.push(fullSlug.slice(0, -suffix.length));
        }
      });

      if (!fullSlug.endsWith('_patch')) variations.push(fullSlug + '_patch');
      if (!fullSlug.endsWith('_leather')) variations.push(fullSlug + '_leather');

      return variations;
    }

    function elasticSlug(elasticName) {
      return (elasticName || '').toString().toLowerCase().trim();
    }

    function buildImageUrlVariations(hatName, materialName, elasticName) {
      const hatVariations = hatSlugVariations(hatName);
      const elastic = elasticSlug(elasticName);
      if (!hatVariations.length || !elastic) return [];
      const materialVariations = materialSlugVariations(materialName);
      const urls = [];
      hatVariations.forEach(function(hat) {
        materialVariations.forEach(function(material) {
          urls.push('https://res.cloudinary.com/' + TEE_HOLDER_CLOUD + '/image/upload/' + TEE_HOLDER_FOLDER + '/' +
            hat + '-' + material + '-tee_holder-' + elastic + '_elastic.jpg');
        });
      });
      return urls;
    }

    function getHatColor() {
      const el = document.querySelector('[data-tee-holder-hat-color]');
      return el ? el.getAttribute('data-tee-holder-hat-color') : '';
    }

    function setImageWithFallback(img, urls, onSuccess) {
      if (!img || !urls || !urls.length) return;
      let attemptIndex = 0;
      function tryNext() {
        if (attemptIndex >= urls.length) {
          img.style.opacity = '0.3';
          img.alt = 'Preview not yet available';
          return;
        }
        const url = urls[attemptIndex++];
        img.src = url;
      }
      img.onerror = function() { tryNext(); };
      img.onload = function() {
        this.style.opacity = '1';
        if (onSuccess) onSuccess(this.src);
      };
      tryNext();
    }

    function updateLeatherImages() {
      const hatColor = getHatColor();
      if (!hatColor || !pendingElastic) return;
      modal.querySelectorAll('[data-tee-holder-style]').forEach(function(card) {
        const materialName = card.getAttribute('data-tee-holder-style');
        const urlVariations = buildImageUrlVariations(hatColor, materialName, pendingElastic);
        const img = card.querySelector('img');
        const zoomTrigger = card.querySelector('[data-zoomable]');
        setImageWithFallback(img, urlVariations, function(loadedUrl) {
          if (zoomTrigger) zoomTrigger.setAttribute('data-zoom-src', loadedUrl);
        });
      });
    }

    function updateConfirm() {
      confirmBtn.disabled = !(pendingStyle && pendingElastic);
    }

    function updatePreview() {
      if (pendingElastic && pendingStyle && previewText) {
        const productTitle = (document.title.split(' – ')[0].split(' | ')[0] || 'Your hat').trim();
        previewText.innerHTML = '<strong>' + productTitle + '</strong><br>' + pendingStyle + ' + ' + pendingElastic + ' elastic';
        const previewImg = modal.querySelector('[data-tee-holder-preview-img]');
        if (previewImg) {
          const hatColor = getHatColor();
          const urlVariations = buildImageUrlVariations(hatColor, pendingStyle, pendingElastic);
          if (urlVariations.length) {
            previewImg.alt = productTitle + ' with ' + pendingStyle + ' + ' + pendingElastic + ' elastic';
            setImageWithFallback(previewImg, urlVariations);
          }
        }
        if (previewSection) previewSection.style.display = 'block';
      } else if (previewSection) {
        previewSection.style.display = 'none';
      }
    }

    if (openBtn) openBtn.addEventListener('click', function() {
      openModal(modal);
      if (!pendingElastic) {
        const blackBtn = modal.querySelector('[data-tee-holder-elastic="Black"]');
        if (blackBtn) blackBtn.click();
      }
    });

    modal.querySelectorAll('[data-tee-holder-elastic]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingElastic = this.dataset.teeHolderElastic;
        modal.querySelectorAll('[data-tee-holder-elastic]').forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        if (styleSection) styleSection.style.display = 'block';
        updateLeatherImages();
        updatePreview();
        updateConfirm();
      });
    });

    modal.querySelectorAll('[data-tee-holder-style]').forEach(function(card) {
      card.addEventListener('click', function() {
        pendingStyle = this.dataset.teeHolderStyle;
        pendingVariantId = this.dataset.teeHolderVariantId;
        modal.querySelectorAll('[data-tee-holder-style]').forEach(function(c) { c.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        updatePreview();
        updateConfirm();
      });
    });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        // Get the currently loaded image URL for the selected style card
        let compositeUrl = '';
        const selectedCard = modal.querySelector('[data-tee-holder-style].is-selected');
        if (selectedCard) {
          const img = selectedCard.querySelector('img');
          if (img && img.src && !img.src.endsWith('placeholder.jpg') && img.naturalWidth > 0) {
            compositeUrl = img.src;
          }
        }
        state.teeHolder = {
          active: true,
          styleTitle: pendingStyle,
          variantId: pendingVariantId ? parseInt(pendingVariantId, 10) : null,
          elastic: pendingElastic,
          compositeUrl: compositeUrl
        };
        updateCardBadge('tee-holder', pendingStyle + ' • ' + pendingElastic + ' elastic');
        closeModal(modal);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        state.teeHolder = { active: false, styleTitle: '', variantId: null, elastic: '', compositeUrl: '' };
        updateCardBadge('tee-holder', '');
        modal.querySelectorAll('.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
        pendingStyle = ''; pendingVariantId = null; pendingElastic = '';
        if (styleSection) styleSection.style.display = 'none';
        if (previewSection) previewSection.style.display = 'none';
        confirmBtn.disabled = true;
        closeModal(modal);
      });
    }
  }

  function setupBallMarker() {
    const card = document.querySelector('[data-upgrade-card="ball-marker"]');
    if (!card) return;

    card.addEventListener('click', function() {
      if (state.ballMarker.active) {
        state.ballMarker = { active: false };
        updateCardBadge('ball-marker', '');
      } else {
        state.ballMarker = { active: true };
        updateCardBadge('ball-marker', 'Added');
      }
    });
  }

  function setupScorecardModal() {
    const modal = document.querySelector('[data-scorecard-modal]');
    if (!modal) return;
    setupModalCloseHandlers(modal);

    const openBtn = document.querySelector('[data-upgrade-card="scorecard"]');
    const confirmBtn = modal.querySelector('[data-scorecard-confirm]');
    const optionsSection = modal.querySelector('[data-scorecard-options-section]');
    const uploadSection = modal.querySelector('[data-scorecard-upload-section]');
    const qtyInput = modal.querySelector('[data-scorecard-qty-input]');
    const qtyDecBtn = modal.querySelector('[data-scorecard-qty-dec]');
    const qtyIncBtn = modal.querySelector('[data-scorecard-qty-inc]');
    const uploadInput = modal.querySelector('[data-scorecard-upload]');
    const uploadLabel = modal.querySelector('[data-scorecard-upload-label]');
    const clearBtn = modal.querySelector('[data-scorecard-clear]');

    let pendingDesignType = '', pendingColor = '', pendingVariantId = null;
    let pendingQty = 1, pendingFile = null, pendingBase64 = null;

    function updateConfirm() {
      if (!pendingDesignType || !pendingColor || pendingQty < 1) { confirmBtn.disabled = true; return; }
      if (pendingDesignType === 'custom' && !pendingFile) { confirmBtn.disabled = true; return; }
      confirmBtn.disabled = false;
    }

    if (openBtn) openBtn.addEventListener('click', function() { openModal(modal); });

    modal.querySelectorAll('[data-scorecard-type]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingDesignType = this.dataset.scorecardType;
        modal.querySelectorAll('[data-scorecard-type]').forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        modal.querySelectorAll('[data-scorecard-variant]').forEach(function(v) {
          v.style.display = v.dataset.scorecardVariant === pendingDesignType ? '' : 'none';
          v.classList.remove('is-selected');
        });
        pendingColor = ''; pendingVariantId = null;
        if (optionsSection) optionsSection.style.display = 'block';
        if (uploadSection) uploadSection.style.display = pendingDesignType === 'custom' ? 'block' : 'none';
        if (pendingDesignType === 'predesigned') {
          pendingFile = null; pendingBase64 = null;
          if (uploadInput) uploadInput.value = '';
          if (uploadLabel) uploadLabel.textContent = 'Click to upload';
        }
        updateConfirm();
      });
    });

    modal.querySelectorAll('[data-scorecard-variant]').forEach(function(card) {
      card.addEventListener('click', function() {
        if (this.dataset.scorecardVariant !== pendingDesignType) return;
        pendingColor = this.dataset.simpleColor;
        pendingVariantId = this.dataset.variantId;
        modal.querySelectorAll('[data-scorecard-variant]').forEach(function(c) { c.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        updateConfirm();
      });
    });

    function setQty(v) {
      pendingQty = Math.max(1, parseInt(v) || 1);
      if (qtyInput) qtyInput.value = pendingQty;
      updateConfirm();
    }
    if (qtyDecBtn) qtyDecBtn.addEventListener('click', function() { setQty(pendingQty - 1); });
    if (qtyIncBtn) qtyIncBtn.addEventListener('click', function() { setQty(pendingQty + 1); });
    if (qtyInput) qtyInput.addEventListener('input', function() { setQty(qtyInput.value); });

    if (uploadInput) {
      uploadInput.addEventListener('change', async function(e) {
        const file = e.target.files[0];
        if (!file || !validateFile(file)) { e.target.value = ''; return; }
        pendingFile = file;
        pendingBase64 = await readFileAsBase64(file);
        if (uploadLabel) uploadLabel.innerHTML = '<span style="color:#16a34a;font-weight:500;">✓ ' + file.name + '</span>';
        updateConfirm();
      });
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        state.scorecard = {
          active: true,
          designType: pendingDesignType,
          color: pendingColor,
          variantId: pendingVariantId ? parseInt(pendingVariantId, 10) : null,
          quantity: pendingQty,
          logoFile: pendingFile,
          logoBase64: pendingBase64
        };
        const label = pendingQty + ' × ' + pendingColor + (pendingDesignType === 'custom' ? ' (custom)' : ' (pre-designed)');
        updateCardBadge('scorecard', label);
        closeModal(modal);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        state.scorecard = { active: false, designType: '', color: '', variantId: null, quantity: 0, logoFile: null, logoBase64: null };
        updateCardBadge('scorecard', '');
        modal.querySelectorAll('.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
        modal.querySelectorAll('[data-scorecard-variant]').forEach(function(v) { v.style.display = 'none'; });
        pendingDesignType = ''; pendingColor = ''; pendingVariantId = null;
        pendingQty = 1; pendingFile = null; pendingBase64 = null;
        if (qtyInput) qtyInput.value = 1;
        if (uploadInput) uploadInput.value = '';
        if (uploadLabel) uploadLabel.textContent = 'Click to upload';
        if (optionsSection) optionsSection.style.display = 'none';
        if (uploadSection) uploadSection.style.display = 'none';
        confirmBtn.disabled = true;
        closeModal(modal);
      });
    }
  }

  function setupTeeClipModal() {
    const modal = document.querySelector('[data-tee-clip-modal]');
    if (!modal) return;
    setupModalCloseHandlers(modal);

    const openBtn = document.querySelector('[data-upgrade-card="tee-clip"]');
    const confirmBtn = modal.querySelector('[data-teeclip-confirm]');
    const optionsSection = modal.querySelector('[data-teeclip-options-section]');
    const uploadSection = modal.querySelector('[data-teeclip-upload-section]');
    const qtyInput = modal.querySelector('[data-teeclip-qty-input]');
    const qtyDecBtn = modal.querySelector('[data-teeclip-qty-dec]');
    const qtyIncBtn = modal.querySelector('[data-teeclip-qty-inc]');
    const uploadInput = modal.querySelector('[data-teeclip-upload]');
    const uploadLabel = modal.querySelector('[data-teeclip-upload-label]');
    const clearBtn = modal.querySelector('[data-teeclip-clear]');

    let pendingDesignType = '', pendingColor = '', pendingVariantId = null;
    let pendingQty = 1, pendingFile = null, pendingBase64 = null;

    function updateConfirm() {
      if (!pendingDesignType || !pendingColor || pendingQty < 1) { confirmBtn.disabled = true; return; }
      if (pendingDesignType === 'custom' && !pendingFile) { confirmBtn.disabled = true; return; }
      confirmBtn.disabled = false;
    }

    if (openBtn) openBtn.addEventListener('click', function() { openModal(modal); });

    modal.querySelectorAll('[data-teeclip-type]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingDesignType = this.dataset.teeclipType;
        modal.querySelectorAll('[data-teeclip-type]').forEach(function(b) { b.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        modal.querySelectorAll('[data-teeclip-variant]').forEach(function(v) {
          v.style.display = v.dataset.teeclipVariant === pendingDesignType ? '' : 'none';
          v.classList.remove('is-selected');
        });
        pendingColor = ''; pendingVariantId = null;
        if (optionsSection) optionsSection.style.display = 'block';
        if (uploadSection) uploadSection.style.display = pendingDesignType === 'custom' ? 'block' : 'none';
        if (pendingDesignType === 'predesigned') {
          pendingFile = null; pendingBase64 = null;
          if (uploadInput) uploadInput.value = '';
          if (uploadLabel) uploadLabel.textContent = 'Click to upload';
        }
        updateConfirm();
      });
    });

    modal.querySelectorAll('[data-teeclip-variant]').forEach(function(card) {
      card.addEventListener('click', function() {
        if (this.dataset.teeclipVariant !== pendingDesignType) return;
        pendingColor = this.dataset.teeclipColor;
        pendingVariantId = this.dataset.teeclipVariantId;
        modal.querySelectorAll('[data-teeclip-variant]').forEach(function(c) { c.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        updateConfirm();
      });
    });

    function setQty(v) {
      pendingQty = Math.max(1, parseInt(v) || 1);
      if (qtyInput) qtyInput.value = pendingQty;
      updateConfirm();
    }
    if (qtyDecBtn) qtyDecBtn.addEventListener('click', function() { setQty(pendingQty - 1); });
    if (qtyIncBtn) qtyIncBtn.addEventListener('click', function() { setQty(pendingQty + 1); });
    if (qtyInput) qtyInput.addEventListener('input', function() { setQty(qtyInput.value); });

    if (uploadInput) {
      uploadInput.addEventListener('change', async function(e) {
        const file = e.target.files[0];
        if (!file || !validateFile(file)) { e.target.value = ''; return; }
        pendingFile = file;
        pendingBase64 = await readFileAsBase64(file);
        if (uploadLabel) uploadLabel.innerHTML = '<span style="color:#16a34a;font-weight:500;">✓ ' + file.name + '</span>';
        updateConfirm();
      });
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        state.teeClip = {
          active: true,
          designType: pendingDesignType,
          color: pendingColor,
          variantId: pendingVariantId ? parseInt(pendingVariantId, 10) : null,
          quantity: pendingQty,
          logoFile: pendingFile,
          logoBase64: pendingBase64
        };
        const label = pendingQty + ' × ' + pendingColor + (pendingDesignType === 'custom' ? ' (custom)' : ' (pre-designed)');
        updateCardBadge('tee-clip', label);
        closeModal(modal);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        state.teeClip = { active: false, designType: '', color: '', variantId: null, quantity: 0, logoFile: null, logoBase64: null };
        updateCardBadge('tee-clip', '');
        modal.querySelectorAll('.is-selected').forEach(function(el) { el.classList.remove('is-selected'); });
        modal.querySelectorAll('[data-teeclip-variant]').forEach(function(v) { v.style.display = 'none'; });
        pendingDesignType = ''; pendingColor = ''; pendingVariantId = null;
        pendingQty = 1; pendingFile = null; pendingBase64 = null;
        if (qtyInput) qtyInput.value = 1;
        if (uploadInput) uploadInput.value = '';
        if (uploadLabel) uploadLabel.textContent = 'Click to upload';
        if (optionsSection) optionsSection.style.display = 'none';
        if (uploadSection) uploadSection.style.display = 'none';
        confirmBtn.disabled = true;
        closeModal(modal);
      });
    }
  }

  function setupAddToCartInterceptor() {
    const form = getProductForm();
    if (!form) return;

    form.addEventListener('submit', async function(e) {
      const hasUpgrades = state.rope.active || state.teeHolder.active || state.ballMarker.active || state.scorecard.active || state.teeClip.active;
      if (!hasUpgrades) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Processing...'; }

      try {
        const hatVariantId = getMainHatVariantId();
        const hatQty = getMainHatQuantity();
        if (!hatVariantId) throw new Error('Hat variant not found');

        const productTitleEl = document.querySelector('.product__title, h1.product-title, h1[class*="product"]');
        const productTitle = productTitleEl ? productTitleEl.textContent.trim() : document.title.split(' – ')[0].split(' | ')[0].trim();
        const selectedSizeEl = document.querySelector('.size-picker__option.is-selected .size-picker__name, fieldset.product-form__input input:checked, select[name^="options"] option:checked');
        let selectedSize = '';
        if (selectedSizeEl) {
          if (selectedSizeEl.tagName === 'OPTION' || selectedSizeEl.tagName === 'INPUT') {
            selectedSize = (selectedSizeEl.value || selectedSizeEl.textContent || '').trim();
          } else {
            selectedSize = selectedSizeEl.textContent.trim();
          }
        }
        if (!selectedSize) {
          const variantTitleInput = document.querySelector('input[name="id"]');
          if (variantTitleInput) {
            const variantSelect = document.querySelector('select[name="id"] option[value="' + variantTitleInput.value + '"]');
            if (variantSelect) selectedSize = variantSelect.textContent.split(' - ').pop().trim();
          }
        }
        const forHatLabel = selectedSize ? (productTitle + ' — ' + selectedSize) : productTitle;

        const items = [];
        const cartAttributes = {};
        const cartNoteParts = [];

        items.push({ id: parseInt(hatVariantId, 10), quantity: hatQty });

        if (state.rope.active) {
          let ropeRefUrl = '';
          if (state.rope.refImageBase64 && state.rope.refImageFile) {
            if (submitBtn) submitBtn.textContent = 'Uploading rope reference...';
            const refUpload = await uploadToCloudinary(state.rope.refImageBase64, state.rope.refImageFile.name);
            ropeRefUrl = refUpload.secure_url;
            state.rope.refImageUrl = ropeRefUrl;
            cartAttributes['Rope_Reference_Image_URL'] = ropeRefUrl;
            cartNoteParts.push('Rope reference image: ' + ropeRefUrl);
            if (submitBtn) submitBtn.textContent = 'Processing...';
          }

          const props = { 'For hat': forHatLabel, 'Action': state.rope.action.charAt(0).toUpperCase() + state.rope.action.slice(1) };
          if (state.rope.color) props['Rope Color'] = state.rope.color;
          if (state.rope.customColor) props['Custom color description'] = state.rope.customColor;
          if (ropeRefUrl) props['Rope Reference Image'] = ropeRefUrl;

          const ropeRes = await fetch('/products/' + ROPE_HANDLE + '.js');
          if (!ropeRes.ok) throw new Error('Could not fetch rope product');
          const ropeData = await ropeRes.json();
          const targetAction = state.rope.action.toLowerCase();
          const matchingVariant = ropeData.variants.find(function(v) {
            return v.title.toLowerCase().includes(targetAction);
          });
          if (!matchingVariant) {
            throw new Error('No rope variant found matching action: ' + targetAction);
          }
          items.push({ id: matchingVariant.id, quantity: hatQty, properties: props });
        }

        if (state.ballMarker.active) {
          items.push({ handle: BALL_MARKER_HANDLE, quantity: hatQty, properties: { 'For hat': forHatLabel } });
        }

        if (state.teeHolder.active && state.teeHolder.variantId) {
          const teeProps = { 'For hat': forHatLabel, 'Style': state.teeHolder.styleTitle, 'Elastic': state.teeHolder.elastic };
          if (state.teeHolder.compositeUrl) {
            teeProps['Composite Image'] = state.teeHolder.compositeUrl;
          }
          items.push({
            id: state.teeHolder.variantId,
            quantity: hatQty,
            properties: teeProps
          });
        }

        if (state.scorecard.active && state.scorecard.variantId) {
          const props = { 'For hat': forHatLabel, 'Color': state.scorecard.color, 'Design': state.scorecard.designType === 'custom' ? 'Custom' : 'Pre-designed' };
          if (state.scorecard.designType === 'custom' && state.scorecard.logoBase64) {
            const upload = await uploadToCloudinary(state.scorecard.logoBase64, state.scorecard.logoFile.name);
            props['Logo'] = upload.secure_url;
            cartAttributes['Scorecard_Logo_URL'] = upload.secure_url;
            cartNoteParts.push('Scorecard book logo: ' + upload.secure_url);
          }
          items.push({
            id: state.scorecard.variantId,
            quantity: state.scorecard.quantity,
            properties: props
          });
        }

        if (state.teeClip.active && state.teeClip.variantId) {
          const props = { 'For hat': forHatLabel, 'Color': state.teeClip.color, 'Design': state.teeClip.designType === 'custom' ? 'Custom' : 'Pre-designed' };
          if (state.teeClip.designType === 'custom' && state.teeClip.logoBase64) {
            const upload = await uploadToCloudinary(state.teeClip.logoBase64, state.teeClip.logoFile.name);
            props['Logo'] = upload.secure_url;
            cartAttributes['TeeClip_Logo_URL'] = upload.secure_url;
            cartNoteParts.push('Tee clip logo: ' + upload.secure_url);
          }
          items.push({
            id: state.teeClip.variantId,
            quantity: state.teeClip.quantity,
            properties: props
          });
        }

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.handle && !item.id) {
            const productRes = await fetch('/products/' + item.handle + '.js');
            if (!productRes.ok) throw new Error('Could not fetch upgrade product: ' + item.handle);
            const productData = await productRes.json();
            const firstAvailable = productData.variants.find(function(v) { return v.available; }) || productData.variants[0];
            item.id = firstAvailable.id;
            delete item.handle;
          }
        }

        // Shopify shows items newest-first, so reverse to get hat on top
        items.reverse();

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addRes.ok) {
          const errData = await addRes.json();
          throw new Error(errData.description || 'Failed to add to cart');
        }

        if (Object.keys(cartAttributes).length || cartNoteParts.length) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: cartAttributes,
              note: cartNoteParts.join('\n')
            })
          });
        }

        window.location.href = '/cart';
      } catch (err) {
        console.error('Add to cart error:', err);
        alert('Error adding to cart: ' + err.message);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      }
    }, true);
  }

  function init() {
    setupRopeModal();
    setupTeeHolderModal();
    setupBallMarker();
    setupScorecardModal();
    setupTeeClipModal();
    setupAddToCartInterceptor();
    addLeadTimeNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();